import React from 'react'
import { ErrorBoundary } from 'secondstep-components'
import PropTypes from 'prop-types'
import { Route } from 'react-router'
import SchoolSummary from 'pages/SchoolSummary'
import { K8_REPORT_UNIT_SECTION } from './constants'
import { PageWrapper } from './component.styles'

const LessonCompletionReport = ({
  entry,
  isDwbReportRoute,
  match,
  navigationHandler,
  schoolEmptyDisplay,
}) => {
  return (
    <ErrorBoundary>
      <PageWrapper>
        {isDwbReportRoute ? (
          <SchoolSummary
            entry={entry}
            isDwbReportRoute
            k8ReportUnitSection={K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS}
            navigationHandler={navigationHandler}
            schoolEmptyDisplay={schoolEmptyDisplay}
          />
        ) : (
          <Route
            path={`${match.path}/:unitSection`}
            render={routeProps => (
              <SchoolSummary
                entry={entry}
                isDwbReportRoute={false}
                k8ReportUnitSection={routeProps.match.params.unitSection}
                navigationHandler={navigationHandler}
                schoolEmptyDisplay={schoolEmptyDisplay}
              />
            )}
          />
        )}
      </PageWrapper>
    </ErrorBoundary>
  )
}

LessonCompletionReport.propTypes = {
  entry: PropTypes.object,
  isDwbReportRoute: PropTypes.bool,
  match: PropTypes.object,
  navigationHandler: PropTypes.func,
  schoolEmptyDisplay: PropTypes.object,
  siteId: PropTypes.string,
}

export default LessonCompletionReport
